import { render, staticRenderFns } from "./epasCopyAudit.vue?vue&type=template&id=08bc2e12&scoped=true&"
import script from "./epasCopyAudit.vue?vue&type=script&lang=js&"
export * from "./epasCopyAudit.vue?vue&type=script&lang=js&"
import style0 from "./epasCopyAudit.vue?vue&type=style&index=0&id=08bc2e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc2e12",
  null
  
)

export default component.exports